<template>
    <route-form
        v-model                    = "copyPlaceholder"
        v-bind:isConcept           = "true"
        v-bind:limitedDestinations = "options.dayDestinations"
        v-bind:isTaggable          = "false"
    >
        <button
            class="button is-close"
            v-on:click="$emit('cancel')"
            title="Verwerfen"
        ><i class="material-icons">close</i></button>

        <button
            class        = "button is-save is-primary"
            v-bind:class = "{ 'is-loading': isLoading }"
            v-on:click   = "save"
            title        = "Speichern"
        ><i class="material-icons">check</i></button>
    </route-form>
</template>



<script>
import { notifyError } from '@components/Notification';
import RouteForm from '@orders/placeholders/components/forms/Route';
import mixins from './mixins';


export default {
    mixins: [mixins],


    data: function () {
        return {
            copyPlaceholder: {
                routeDescription: '',
                pricePerPerson: {amount: '0', currency: 'EUR'},
                predefinedRouteDetail: null,
                timeOfDay: null,
                clientOffer: {
                    status: 'included',
                    priceType: 'per_person',
                }
            }
        }
    },


    methods: {
        save: function () {
            if (this.copyPlaceholder.predefinedRouteDetail){
                this.$emit('save', this.copyPlaceholder);

            } else {
                notifyError('Routenstichpunkte kann nicht leer sein!');
            }
        },


        onKeyUp: function (event) {
            if (event.keyCode === 13 &&
                this.placeholder === undefined    &&
                this.copyPlaceholder.predefinedRouteDetail
                ) {
                this.$nextTick(() => {
                    if (this.placeholderStringify === JSON.stringify(this.copyPlaceholder)) {
                        this.save();
                    }
                });
            }
        }
    },


    components: {
        RouteForm
    }
}
</script>
